import { Stack, Typography } from "@mui/material";
import { t } from "i18next";
import DashboardTable from "../../../components/Dashboard/DashboardTable";
import Template from "../../../components/Dashboard/Template";

const diplayRows = [
  "date_and_month",
  "worker_upcomming_job_detail",
  "worker_upcomming_job_price",
];

const WorkerUpcommingJobs = ({ allJobs, isLoading }) => {
  return (
    <Template
      primaryHeading={t("upcomingJobActivity")}
      secondaryHeading={t("viewUpcomingJobs")}
    >
      {allJobs?.length == 0 && isLoading?.states === false ? (
        <Stack height={"100%"} alignItems={"center"} justifyContent={"center"}>
          <Typography variant="h5" fontWeight={600}>
            {t("noUpcomingJobsFound")}
          </Typography>
        </Stack>
      ) : (
        <DashboardTable
          showHeader={false}
          tableData={allJobs}
          diplayRows={diplayRows}
        />
      )}
    </Template>
  );
};

export default WorkerUpcommingJobs;
